import { UrlHelper } from './UrlHelper';

const TokenHelper = {};

TokenHelper.append = (url, tokenParamName) => {
    tokenParamName = tokenParamName || 'lww_st';
    const token = window.hubCookie.getToken() || '';
    const query = {};
    query[tokenParamName] = token;
    const newUrl = UrlHelper.updateQueryString(url, query);
    return newUrl;
};

export { TokenHelper };


// WEBPACK FOOTER //
// ./src/nams2020/common/utils/TokenHelper.js